import { parseJwtPayload } from '@omniflow/browser-bus'

type StoreIdentity = { username: string | null; tenantId: string | null }
type FormIdentity = { username: string; tenantId: string }

/**
 * Логин и тенант для перелогина в модалке (SESSRENEW O12): известные стору значения
 * побеждают форму (разблокировка поля не даёт сменить личность), иначе — форма с trim.
 */
export const reloginCredentials = (store: StoreIdentity, form: FormIdentity): FormIdentity => ({
  username: store.username ?? form.username.trim(),
  tenantId: store.tenantId ?? form.tenantId.trim(),
})

/**
 * Страховка: новый токен принадлежит тому же пользователю и тенанту, что прежний.
 * Прежняя личность пуста или неполна — сравнивать не с чем, и это отказ, а не пропуск:
 * иначе модалка перелогина под открытой страницей впустила бы любого пользователя (O12).
 */
export const isSameIdentity = (
  prev: { userId: string | null; tenantId: string | null },
  newToken: string,
): boolean => {
  if (prev.userId === null || prev.tenantId === null) return false
  const claims = parseJwtPayload(newToken)
  if (!claims) return false
  return claims.sub === prev.userId && claims.tenantId === prev.tenantId
}
